module.exports = __webpack_public_path__ + "static/img/data1.f57d93e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data1.jpg
// module id = OUvS
// module chunks = 9